import Icon from 'snippets/icon/icon'

function CustomModalDialog({ header, content, footer, id, type = 'modal', disableClickOverlay = false, classClose = 'w-8 h-8 p-2', classMain = '', classContent = '', classHeader = '' }) {
  return (
    <modal-dialog data-target={id} data-type={type} data-scroll-target='.modal-dialog-inner' disable-click-overlay={disableClickOverlay}>
      <div className={`modal-dialog-content js-content-modal-dialog flex flex-col relative ${classMain}`} body-scroll-lock-ignore>
        <div className={`relative ${classHeader}`}>
          {header}
          <button type='button' className={`js-close-modal-dialog absolute top-3 right-4 ${classClose}`}>
            <Icon name='icon-close-outline' className='h-4 w-4 text-default' />
          </button>
        </div>
        <div className={`modal-dialog-inner ${classContent}`} body-scroll-lock-ignore>{content}</div>
        {footer}
      </div>
    </modal-dialog>
  )
}

export default CustomModalDialog
